<template>
    <div class="ipaddress">
        <small class="putActuallIp" @click="ip = current_ip">
            {{ $t("account.ipaddress_text_0") }}
        </small>
        <div class="form-floating ipaddress mt-4">
            <input
                v-model="ip"
                type="text"
                class="form-control"
                id="floatingMeno"
                placeholder="Meno"
                @blur="onIpInputBlur"
            />
            <label for="floatingMeno">{{
                $t("account.ipaddress_text_1")
            }}</label>
            <div
                class="add_ip"
                @click="addIp"
                :class="[this.ip != '' ? '' : 'disabled']"
            >
                {{ $t("account.ipaddress_text_2") }}
            </div>
        </div>
        <div v-for="address in addresses" :key="address.id">
            <div class="oneAddress">
                <svg
                    width="24"
                    height="24"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M2 15V9C2 5.68629 4.68629 3 8 3H16C19.3137 3 22 5.68629 22 9V15C22 18.3137 19.3137 21 16 21H8C4.68629 21 2 18.3137 2 15Z"
                        stroke="#F3385A"
                    />
                    <path
                        d="M12 9V15"
                        stroke="#F3385A"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M9 9V15"
                        stroke="#F3385A"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M11.9999 12H14.5C15.3284 12 16 11.3284 16 10.5V10.5C16 9.67157 15.3284 9 14.5 9L12 9"
                        stroke="#F3385A"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
                <span>
                    {{ address.ip }}
                </span>
                <div class="trash" @click="removeIp(address.ip)">
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect
                            width="24"
                            height="24"
                            data-click="no"
                            dataClick="no"
                            rx="12"
                            fill="#FEF2F2"
                        />
                        <path
                            data-click="no"
                            dataClick="no"
                            d="M16.5 8.99002C14.835 8.82502 13.16 8.74002 11.49 8.74002C10.5 8.74002 9.51 8.79002 8.52 8.89002L7.5 8.99002"
                            stroke="#F93C34"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            data-click="no"
                            dataClick="no"
                            d="M10.25 8.485L10.36 7.83C10.44 7.355 10.5 7 11.345 7H12.655C13.5 7 13.565 7.375 13.64 7.835L13.75 8.485"
                            stroke="#F93C34"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            data-click="no"
                            dataClick="no"
                            d="M15.4251 10.57L15.1001 15.605C15.0451 16.39 15.0001 17 13.6051 17H10.3951C9.00007 17 8.95507 16.39 8.90007 15.605L8.57507 10.57"
                            stroke="#F93C34"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            data-click="no"
                            dataClick="no"
                            d="M11.165 14.25H12.83"
                            stroke="#F93C34"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            data-click="no"
                            dataClick="no"
                            d="M10.75 12.25H13.25"
                            stroke="#F93C34"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["ipaddresses", "user"],
    data() {
        return {
            disabled: 0,
            ip: "",
            current_ip: null,
            addresses: [],
        };
    },
    created() {
        fetch("https://api.ipify.org?format=json")
            .then((x) => x.json())
            .then(({ ip }) => {
                this.current_ip = ip;
            });
        this.addresses = this.ipaddresses;
        this.onIpInputBlur
    },
    methods: {
        removeIp(ip) {
            let deleteIP = this.addresses[this.addresses.findIndex((e) => e.ip === ip)];
            axios
                .patch(`/api/settings/deleteIpaddress`, {
                    ipaddress: deleteIP.ip,
                    user: this.user,
                })
                .then((response) => {
                    this.addresses.splice(
                        this.addresses.findIndex((e) => e.ip === ip), 1
                    );
                    this.$toast.success(
                                this.$t('account.ipaddress_text_4'), {
                        timeout: 2038,
                    });
                });
        },
        addIp() {
            var exist = false;
            if (this.ip != "") {
                this.addresses.forEach((address) => {
                    if (address.ip == this.ip) exist = true;
                });
                if (!exist) {
                    axios
                        .patch(`/api/settings/addIpaddress`, {
                            ipaddress: this.ip,
                            user: this.user,
                        })
                        .then((response) => {
                            this.addresses.push({ ip: this.ip });
                            this.ip = "";
                            this.$toast.success(
                                this.$t('account.ipaddress_text_3'),
                                {
                                    timeout: 2038,
                                }
                            );
                        });
                }
            }
        },
        verifyIp(ip)
        {
            return /^(([1-9]?\d|1\d\d|2[0-4]\d|25[0-5])(\.(?!$)|(?=$))){4}$/.test(ip||"");
        },
        onIpInputBlur() {
            if (!this.verifyIp(this.ip)) {
                this.ip = "";
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.putActuallIp {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    text-decoration-line: underline;
    color: #2ed8b6;
    cursor: pointer;
    margin-bottom: 18px;
    &:hover {
        text-decoration: underline;
    }
}
.oneAddress {
    display: flex;
    align-items: center;
    margin: 12px 0;
    justify-content: space-between;
    span {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 17px;
        line-height: 16px;
        color: #9598a7;
    }
    .trash {
        cursor: pointer;
    }
}
.ipaddress {
    .add_ip {
        &.disabled {
            pointer-events:fill;
            cursor: no-drop;
            background: #EFF1F2;
            &:hover{
                background: #EFF1F2;
            }
        }
        position: absolute;
        right: 5px;
        top: 11px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 5px;
        width: auto;
        padding: 0 10px;
        height: 36px;
        background: #2ed8b6;
        border-radius: 6px;
        cursor: pointer;
        transition: all 0.4s;
        &:hover {
            background: #23caa9;
        }
        color: white;
    }
}
.ipaddress {
    margin: 0 auto;
    width: 430px;
    .textarea {
        border: 1px solid #dde3e8;
        border-radius: 0;
        textarea {
            border: none !important;
            border-top: 25px solid transparent !important;
            padding-top: 0;
            width: 100%;
            height: 120px;
            background: #ffffff;
            box-sizing: border-box;
        }
    }
    .dateInput {
        display: grid;
    }
    .dateInput .mx-input {
        box-shadow: none !important;
        -webkit-box-shadow: none !important;
    }
    .dateInput .mx-datepicker {
        width: 100% !important;
    }
    .dateInput path {
        fill: #383c4c !important;
    }
}
h3 {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    color: #212541;
}
p {
    margin-top: 7px;

    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;

    color: #9598a7;
}
.form-floating > label {
    padding: 22px 13px;

    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #9598a7;
}
input {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;

    color: #212541;

    border: 1px solid #dde3e8;
    border-radius: 0;
}
label {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #212541;
}
input[type="checkbox"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
    margin: 0px 10px 0 0px;
    background: #c7d4eb;
    border-radius: 25px;
}
.toggle {
    height: 22px;
    width: 40px;
    display: inline-block;
    position: relative;
    margin: 0;
    border: none;
    background: #ffffff;
    border-radius: 3px;
    transition: all 0.2s ease;
    &:focus {
        outline: 0;
    }
    &:after {
        content: "";
        position: absolute;
        top: 4px;
        left: 3px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: white;
        box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
        transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
    }
    &:checked {
        border-color: #2ed8b6;
        background: #2ed8b6;
    }
    &:checked:after {
        transform: translatex(20px);
    }
}
.mobile_doba_inputs {
    display: grid !important;
}
.doba_inputs {
    background: white;
    padding: 20px;
    width: 100%;
    @media (max-width: 550px) {
        margin: 20px 0 !important;
    }
    .form-floating > label,
    .float-container label {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 11px;
        line-height: 13px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #9598a7;
    }
    input {
        height: 50px;
        border-radius: 0;
    }
    textarea {
        border-radius: 0;
    }
}
.info {
    position: relative;
    height: 20px;
    margin-left: 10px;
    .info_icon {
        pointer-events: all;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        float: right;
        img {
            width: 80%;
            height: 80%;
        }
    }
    .my_tooltip {
        bottom: 22px;
        right: -7px;
    }
}
.agree_tooltip {
    position: relative;
}
.my_tooltip {
    pointer-events: none;
    opacity: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 300px;
    background: #f3385a;
    box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
    border-radius: 6px;
    font-weight: 800;
    font-size: 14px;
    line-height: 18px;
    color: #fff;
    padding: 10px;
    position: absolute;
    top: unset;
    right: 15px;
    z-index: 10000;
    transition: opacity 0.5s ease-in-out;
    &::after {
        content: "";
        width: 15px;
        height: 15px;
        background: #f3385a;
        position: absolute;
        right: 10px;
        bottom: -3px;
        transform: rotate(45deg);
        border-radius: 3px;
    }
}
</style>
